import { render, staticRenderFns } from "./ToxprintsMoreMenu.vue?vue&type=template&id=7867145a"
import script from "./ToxprintsMoreMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./ToxprintsMoreMenu.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports